import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const TableContainer = styled.div<{ isExpanded?: boolean; minHeight?: string, remHeight?: number }>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-x: auto;
  overflow-y: auto;
  scrollbar-width: none;
  border-radius: ${pxToRem(16)};
  box-shadow:
    0px ${pxToRem(9)} ${pxToRem(14.5)} 0px rgba(0, 0, 0, 0.06),
    0px 0px 0px ${pxToRem(6)} rgba(31, 10, 53, 0.05);
  transition: height 0.3s ease;
  padding-top: 0;
  padding-bottom: 0;
  height: ${({ isExpanded, remHeight }) => (isExpanded ? "100%" : "calc(100% - " + pxToRem(remHeight) + ")")};
`;

export const StyledTable = styled.table`
  border-collapse: collapse;
  width: 100%;
`;

export const TableHeader = styled.thead`
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: rgb(255, 255, 255);

  th {
    text-align: left;
    color: rgb(31, 10, 53);
    font-size: ${pxToRem(18)};
    font-weight: 600;
    line-height: ${pxToRem(22)};
    padding-top: ${pxToRem(25)};
    padding-bottom: ${pxToRem(10)};
  }

  span {
    white-space: nowrap;
  }
`;


export const TableRow = styled.tr<{ isExpanded?: boolean }>`
  position: ${({ isExpanded }) => (isExpanded ? "sticky" : "relative")};
  top: ${({ isExpanded }) => (isExpanded ? pxToRem(100) : "auto")};
  background-color: ${({ isExpanded }) => (isExpanded ? "white" : "transparent")};
  z-index: ${({ isExpanded }) => (isExpanded ? 2 : 1)};
  transition: top 0.3s ease;
  padding-top: ${pxToRem(5)};
  padding-bottom: ${pxToRem(5)};

  &:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: ${pxToRem(20)};
    right: ${pxToRem(20)};
    height: ${pxToRem(1)};
    z-index: 0;
    background-color: rgb(235, 235, 235);
  }
`;

export const TableBody = styled.tbody``;

export const TableCell = styled.td<{ isHidden?: boolean }>`
  padding-top: ${pxToRem(10)};
  padding-bottom: ${pxToRem(10)};
  font-size: ${pxToRem(18)};
  font-weight: 400;
  padding-left: ${pxToRem(54)};

  &:last-child {
    padding-right: ${pxToRem(35)};
    padding-left: ${pxToRem(5)};
  }

  div.content {
    visibility: ${({ isHidden }) => (isHidden ? "hidden" : "visible")};
    align-items: center;
    gap: ${pxToRem(10)};
    flex-wrap: nowrap;
    text-overflow: ellipsis;
  }
`;

export const DragHandleCell = styled(TableCell)`
  width: ${pxToRem(64)};
  padding-left: ${pxToRem(24)};
  padding-right: ${pxToRem(10)};

  div.content {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const TableHeadCell = styled.div`
  display: flex;
  align-items: center;
  padding-top: ${pxToRem(28)};
  padding-left: ${pxToRem(28)};
  padding-bottom: ${pxToRem(25)};

  // th:first-child & {
  //   padding-left: ${pxToRem(28)};
  // }

  span {
    margin-left: ${pxToRem(19)};
  }
`;


export const PaginatorWrapper = styled.div`
  margin-top: auto;
  position: sticky;
  bottom: 0;
  background-color: rgb(255, 255, 255);
  padding-top: ${pxToRem(10)};
  padding-bottom: ${pxToRem(10)};
  z-index: 2;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding-top: ${pxToRem(10)};
  padding-bottom: ${pxToRem(10)};
`;


export const FilterIcon = styled.img`
  width: ${pxToRem(10)};
  height: auto;
`;  


export const SortIcon = styled.img`
  width: ${pxToRem(7)};
  height: auto;
`;

export const DragHandleButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${pxToRem(32)};
  height: ${pxToRem(32)};
  border: none;
  background: transparent;
  color: inherit;
  cursor: grab;
  padding: 0;

  &[data-dragging="true"] {
    cursor: grabbing;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const DragHandleIcon = styled.img`
  width: ${pxToRem(20)};
  height: ${pxToRem(20)};
`;